import { Box, Toolbar, Typography } from "@mui/material";
import { useState } from "react";
import { getAllPlayoffs } from "../../../apis/Playoff";
import { FilterAutocomplete } from "../../Form/FilterAutocomplete";
import DragAndDropItems from "../DragAndDropItems";
import { axiosInstance } from "../../../config/axios";

export const Group = () => {
	const [groups, setGroups] = useState([]);
	const handleChange = (name, item) => {
		setGroups(
			item?.groups?.map((group) => ({
				id: group.id,
				label: group.name,
				icon: group.category?.logo,
				category: group.category?.name,
			})) || [] // fallback if item.groups is undefined/null
		);
	};

	const handleChangeOrder = async (values) => {
		const order = values.map((item, index) => ({
			id: item.id,
			order: index + 1,
		}));
		const res = await axiosInstance.post("group-order", order);
		console.log("====================================");
		console.log(res);
		console.log("====================================");

		// alert("Current order:\n" + order.join("\n"));
		console.log("Current order:", order);
	};

	return (
		<Box>
			<Toolbar disableGutters>
				<Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
					Group Ordering
				</Typography>

				<Box sx={{ width: { xs: "100%", md: "25%", xl: "20%" } }}>
					<FilterAutocomplete
						fetchOptions={getAllPlayoffs}
						label={"Playoff"}
						handleChange={handleChange}
						name={"playoff"}
						reset={false}
						setReset={() => { }}
					/>
				</Box>
			</Toolbar>

			<Box sx={{ pt: 3 }}>
				{groups.length ? (
					<DragAndDropItems
						items={groups}
						handleChange={handleChangeOrder}
					/>
				) : (
					<></>
				)}
			</Box>
		</Box>

		// );
	);
};
